// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* for tag component use */\n.el-tag + .el-tag[data-v-6a0d067c] {\n  margin-left: 10px;\n}\n.button-new-tag[data-v-6a0d067c] {\n  margin-left: 10px;\n  height: 32px;\n  line-height: 30px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.input-new-tag[data-v-6a0d067c] {\n  width: 90px;\n  margin-left: 10px;\n  vertical-align: bottom;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
